<template>
<!-- <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader"> -->
  <div class="side-wrapper container-fluid py-4">
    <div class="row">
      <div class="col-md-12">
        <div class="section-wrapper py-3">
         <div class="root-img d-flex" v-if="contractor_details_loaded && contractor_details.status">
              <img
                :src="$root.serverBasePath + '/verified.png'"
                alt="Strata Connex"
                height="40px"
              />

              <p class="ml-3 mb-0">
                Verified by Strata Connex<br />
                <span>100% Compliant</span>
              </p>
          </div>
          <div class="root-img d-flex" v-else>
              <i
                style="font-size: 40px"
                class="fas fa-exclamation-circle fa-2x unverified"
              ></i>

              <p class="ml-3 mb-0">Not Verified by Strata Connex<br /></p>
          </div>

          <div class="sec-btn mt-5">
            <router-link :to="{ name: 'contractor-documents' }"  class="btn btn-outline-primary">
                Manage Compliance
            </router-link>

          <button
                        @click="complianceExportAll()"
                        type="button"
                        class="btn btn-primary ml-3"
                        >
                        Export all
                        </button>

            <!-- <router-link :to="{ name: 'contractor-documents' }" @click="complianceExportAll"  class="btn btn-primary">
                Export All
            </router-link> -->
          </div>
        </div>
      </div>
    </div>

    <div class="detail-section my-2 py-5">
      <div class="row">
        <div class="col-lg-12">
          <DocumentInfoCard
            v-if="contractor_details_loaded"
            type="abn_acn"
            :cardData="contractor_details.active_business"
          />
          <DocumentInfoCard
            v-if="contractor_details_loaded"
            type="license"
            :cardData="contractor_details.active_business"
          />
          <DocumentInfoCard
            v-if="contractor_details_loaded"
            type="insurance"
            :cardData="contractor_details.active_business"
          />
        </div>

        <!-- </div> -->
      </div>
    </div>
  </div>
<!-- </b-overlay> -->
</template>

<script>
import _ from "lodash";
import DocumentInfoCard from "@frontend/pages/contractor/compliance/contractor-documents/DocumentInfoCard.vue";

export default {
  components: {
    DocumentInfoCard,
  },
  computed: {
    computeAbnAcnCardData() {
      return {
        title: "ABN/ACN",
        status: this.contractor_details.active_business.abn_acn_status,
        abn_acn: {
          abn_acn: this.contractor_details.active_business.abn_acn,
          company_name: this.contractor_details.active_business.company_name,
          abn_acn_info: this.contractor_details.active_business.abn_acn_info,
        },
      };
    },
    computeLicenseCardData() {
      let returnData = [];
      _.each(this.contractor_details.active_business.license, (license) => {
        returnData.push({
          title: "Contractor Licence",
          status: license.licence_status,
          license: {
            licence_type: license.licence_type,
            compliance: license.compliance,
            licence_info:
              this.contractor_details.active_business.license.licence_info,
          },
        });
      });
      return returnData;
    },
    computeInsurancesCardData() {
      let returnData = [];
      _.each(
        this.contractor_details.active_business.insurances,
        (insurance) => {
          returnData.push({
            title: insurance.insurance_type,
            status: insurance.insurance_status,
            insurance: {
              insurer: insurance.insurer,
              limit: insurance.limit,
              validity_from: insurance.validity_from,
              expiry: insurance.expiry,
            },
          });
        }
      );
      return returnData;
    },
  },
  data() {
    return {
      contractor_details_loaded: false,
      contractor_details: {
        active_business: {},
        status: false
      },
    };
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
       this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/compliance/getDetails", {
          load_active_business: true,
          load_active_business_license: true,
          load_active_business_insurances: true,
          load_active_business_info: true,
        })
        .then((response) => {
          this.contractor_details = response.data.contractor_details;
          this.contractor_details_loaded = true;
          this.$root.$data.bsLoader = false;
          let Status=  response.data.contractor_details.is_verified;
          console.log( response.data.contractor_details.active_business.insurances);
         for (var i = 0; i <  response.data.contractor_details.active_business.license.length; i++) {
             if ( response.data.contractor_details.active_business.license[i].licence_status != "verified") {
                 Status = false;
                 break;
            } else if (response.data.contractor_details.active_business.license[i].licence_status == "verified") {
                 Status = true;
             }
        }

            if(Status!=false){
             for (var i = 0; i < response.data.contractor_details.active_business.insurances.length; i++) {
                 if (response.data.contractor_details.active_business.insurances[i].insurance_status != "verified") {
                     Status = false;
                    break;
                } else if (response.data.contractor_details.active_business.insurances[i].insurance_status == "verified") {
                    Status = true;
                     }
                 }
            }
            this.contractor_details.status= Status;
        }).catch((error) => {
          this.$root.$data.bsLoader = false;
        });
    },
     complianceExportAll() {
      let fileLink = document.createElement("a");
      fileLink.href = this.$root.serverBasePath + '/contractor/compliance/' + this.$store.state.authenticatedUserData.user.id + '/exportAll';
      fileLink.setAttribute("download", "download");
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
      return;

      // return;
      axios({
        url: "api/contractor/compliance/exportAll",
        method: "get",
        responseType: "blob",
        // data: {
        //     format: 'pdf',
        //     quote_id: this.$route.params.id,
        // }
      }).then((response) => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));

        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "file.zip");
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      });
    },
  },
};
</script>

<style scoped>
.side-wrapper {
  background-color: #eff0f6;
}

.unverified {
  color:#e83e8c;
}
</style>
